/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface BulkMatchItem {
  input_name: string;
  matched?: boolean;
  name?: string | null;
  domain?: string | null;
  canonical_id?: string | null;
}
